import axios, { AxiosRequestConfig } from "axios";

// Define the API base URL
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const getPersonalScoreByUserId = async () => {
  try {
    const userId = sessionStorage.getItem("InvitedUserId");

    const access = sessionStorage.getItem("accessToken");

    const initialConfig: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${access}`,
        "Content-Type": "application/json",
      },
    };
    const response = await axios.get(
      `${API_BASE_URL}/v1/Breefs/breef-report/user/${userId}`,
      initialConfig
    );

    return response.data;
  } catch (error) {
    // Handle the error appropriately
    console.error("Error While fetching personal score:", error);
    throw error;
  }
};

/** The participant's own result for this breef, total and level - computed by the server, same every time */
export interface MyResult {
  participant: { firstName: string };
  breef: { id: string; name: string; period?: string; expiry?: string; state: "upcoming" | "open" | "closed" } | null;
  thisBreef: { submitted: boolean; quizScore: number; gamePlayed: boolean; gamePoints: number; breefScore: number; submittedAt: string | null };
  total: { score: number; breefsPlayed: number };
  level: { number: number; heading: string; name: string; minScore: number; imageUrl: string | null; of: number; next: { number: number; minScore: number } | null } | null;
}
export const getMyResult = async (): Promise<MyResult> => {
  const token = sessionStorage.getItem("BreefAccesstoken") || sessionStorage.getItem("accessToken") || "";
  const response = await axios.get(`${API_BASE_URL}/v1/breefs/my-result`, { headers: { Authorization: `Bearer ${token}` } });
  return response.data;
};

